import React from "react";
import { X, Check } from "lucide-react";

const NEGATIVES = ["No delays", "No outsourcing", "No limitations"];
const POSITIVES = [
  "Posters printed before homeroom",
  "Banners ready by game time",
  "Signage on demand, all year long",
];

const PRINT_IMG =
  "https://customer-assets.emergentagent.com/job_school-printing-hub/artifacts/41pladw1_PSP%2036IO.webp";

export default function PrintersSolution() {
  return (
    <section
      data-testid="printers-solution-section"
      className="relative bg-navy text-white py-24 md:py-32 overflow-hidden"
    >
      <div
        aria-hidden
        className="absolute inset-0 opacity-[0.06]"
        style={{
          backgroundImage:
            "linear-gradient(#fff 1px, transparent 1px), linear-gradient(90deg, #fff 1px, transparent 1px)",
          backgroundSize: "64px 64px",
        }}
      />
      <div className="absolute -top-32 -right-32 w-96 h-96 bg-teal/20 rounded-full blur-3xl" />

      <div className="relative max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          <div className="lg:col-span-6 order-2 lg:order-1">
            <div className="text-xs uppercase tracking-[0.2em] font-bold text-teal mb-4">
              The solution
            </div>
            <h2
              data-testid="printers-solution-headline"
              className="font-serif text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-black tracking-tight text-white leading-[1.1]"
            >
              Bring Printing In-House with{" "}
              <span className="text-teal">Print Shop Pro.</span>
            </h2>
            <p className="mt-8 text-lg sm:text-xl text-slate-300 leading-relaxed max-w-2xl">
              Create professional posters, banners, and displays on demand—right
              from your school.
            </p>

            <div className="mt-10 grid sm:grid-cols-2 gap-6">
              <ul className="space-y-4">
                {NEGATIVES.map((n) => (
                  <li key={n} className="flex items-center gap-3">
                    <span className="flex-shrink-0 w-8 h-8 rounded-full bg-white/5 border border-white/15 flex items-center justify-center">
                      <X className="w-4 h-4 text-teal" strokeWidth={3} />
                    </span>
                    <span className="font-serif text-lg font-bold text-white">
                      {n}
                    </span>
                  </li>
                ))}
              </ul>
              <ul className="space-y-4 sm:pl-6 sm:border-l sm:border-white/10">
                {POSITIVES.map((p) => (
                  <li key={p} className="flex items-start gap-3">
                    <span className="flex-shrink-0 mt-0.5 w-8 h-8 rounded-full bg-teal/20 border border-teal/40 flex items-center justify-center">
                      <Check className="w-4 h-4 text-teal" strokeWidth={3} />
                    </span>
                    <span className="text-base font-medium text-slate-200 leading-snug">
                      {p}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="lg:col-span-6 order-1 lg:order-2">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl border border-white/10 bg-white">
              <div className="cmyk-ribbon h-[3px] w-full" aria-hidden />
              <div className="aspect-[5/4] flex items-center justify-center p-6 sm:p-8">
                <img
                  src={PRINT_IMG}
                  alt="Canon imagePROGRAF 36-inch Indoor/Outdoor Print Shop Pro printer with stand"
                  loading="lazy"
                decoding="async"
                  className="max-w-full max-h-full object-contain"
                />
              </div>
              <div className="absolute bottom-6 left-6 right-6 flex items-center gap-3 bg-navy/85 backdrop-blur-md border border-white/10 rounded-xl px-5 py-4">
                <span className="w-2 h-2 rounded-full bg-teal animate-pulse" />
                <span className="text-sm font-semibold text-white">
                  Print Shop Pro 36" — in-house ready
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
